<button class="btn btn--ghost btn--primary d-block d-lg-none mb-3 mx-auto" type="button" (click)="isCollapsed = !isCollapsed">Filtrer la liste</button>
<div class="collapse collapse-filters d-lg-block" id="filters" [collapse]="isCollapsed">
    <button class="navbar-toggler-close d-lg-none btn btn--icon-only btn-icon--header" type="button" (click)="isCollapsed = !isCollapsed">
        <svg class="svg-icon svg-close" aria-hidden="true" focusable="false">
            <use xlink:href="../../../assets/svg-icons/icon-sprite.svg#close"></use>
        </svg>
        <span class="sr-only">Fermer les filtres</span>
    </button>
    <div class="left-box" (scroll)="scroll($event)">
        <form [formGroup]="filtreForm">
            <!-- Structure -->
            <div *ngIf="type === 'Structure'">
                <div class="left-box-container">
                    <fieldset class="mb-2">
                        <legend>Identification de la structure</legend>
                        <div class="form-group">
                            <label for="formInputRaisonSociale">Raison Sociale</label>
                            <input #raisonSocialeHabilitationInput class="form-control" name="formInputRaisonSociale" type="text" formControlName="raisonSociale" id="formInputRaisonSociale" />
                        </div>
                        <div class="form-group">
                            <label for="formInputIdentifiantNational">Identifiant national de la structure</label>
                            <input class="form-control" name="formInputIdentifiantNational" type="text" formControlName="identifiantNational" id="formInputIdentifiantNational" />
                        </div>
                    </fieldset>
                </div>
            </div>

            <!-- Habilitation -->
            <div *ngIf="type === 'Habilitation'">
                <div class="left-box-container">
                    <fieldset class="mb-2">
                        <legend>Identification du porteur</legend>
                        <div class="form-group">
                            <label for="formInputNom">Nom</label>
                            <input #nomPorteurHabilitationInput class="form-control" name="formInputNom" type="text" formControlName="nom" id="formInputNom" />
                        </div>
                        <div class="form-group">
                            <label for="formInputIdentifiantNational">Identifiant national</label>
                            <input class="form-control" name="formInputIdentifiantNational" type="text" formControlName="identifiantNational" id="formInputIdentifiantNational" />
                        </div>
                    </fieldset>
                </div>
                <div *ngIf="rolesFiltre.length > 0" class="left-box-container">
                    <div class="form-group form-group-custom-control">
                        <fieldset>
                            <legend>Rôle</legend>
                            <div formGroupName="roles" *ngFor="let item of filtreForm.get('roles').value | keyvalue; let i = index">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input form-check-input" id="customCheckboxRole{{ i }}" [formControlName]="item.key" [value]="item.value" />
                                    <label class="custom-control-label" for="customCheckboxRole{{ i }}">
                                        {{ item.key }}
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div *ngIf="usagesFiltre.length > 0" class="left-box-container">
                    <div class="form-group form-group-custom-control">
                        <fieldset>
                            <legend>Usages de certificats</legend>
                            <div formGroupName="usages" *ngFor="let item of filtreForm.get('usages').value | keyvalue; let i = index">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input form-check-input" id="customCheckboxUsage{{ i }}" [formControlName]="item.key" [value]="item.value" />
                                    <label class="custom-control-label" for="customCheckboxUsage{{ i }}">
                                        {{ item.key }}
                                    </label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div *ngIf="offresFiltre.length > 0" class="form-group form-group-custom-control">
                    <fieldset>
                        <legend>Offre de certificats</legend>
                        <div formGroupName="offres" *ngFor="let item of filtreForm.get('offres').value | keyvalue; let i = index">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input form-check-input" id="customCheckboxOffreCertificat{{ i }}" [formControlName]="item.key" [value]="item.value" />
                                <label class="custom-control-label" for="customCheckboxOffreCertificat{{ i }}">{{ item.key }}</label>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>

            <!-- Gestion -->
            <div *ngIf="type === 'Gestion'">
                <div class="left-box-container">
                    <fieldset *ngIf="![habilitationType.DELEGUE_PM.toString(), habilitationType.CL_PM.toString()].includes(typeGestion)" class="mb-2">
                        <legend>Identification du porteur</legend>
                        <div class="form-group">
                            <label for="formInputNom">Nom</label>
                            <input #nomPorteurGestionInput class="form-control" name="formInputNom" type="text" formControlName="nom" id="formInputNom" />
                        </div>
                        <div class="form-group">
                            <label for="formInputIdentifiantNational">Identifiant national</label>
                            <input class="form-control" name="formInputIdentifiantNational" type="text" formControlName="identifiantNational" id="formInputIdentifiantNational" />
                        </div>
                    </fieldset>
                    <fieldset *ngIf="[habilitationType.DELEGUE_PM.toString(), habilitationType.CL_PM.toString()].includes(typeGestion)" class="mb-2">
                        <legend>{{ "filtre.tiers.title" | translate }}</legend>
                        <div class="form-group">
                            <label for="formInputRaisonSocialeTiers">{{ "filtre.tiers.raisonSociale" | translate }}</label>
                            <input #raisonSocialeTiersGestionInput class="form-control" name="formInputRaisonSocialeTiers" type="text" formControlName="raisonSocialeTiers" id="formInputRaisonSocialeTiers" />
                        </div>
                        <div class="form-group">
                            <label for="formInputIdNatTiers">{{ "filtre.tiers.idNational" | translate }}</label>
                            <input class="form-control" name="formInputIdNatTiers" type="text" formControlName="idNatTiers" id="formInputIdNatTiers" />
                        </div>
                    </fieldset>
                </div>
                <div class="left-box-container" *ngIf="structuresFiltre.length > 0">
                    <div class="form-group form-group-custom-control">
                        <fieldset>
                            <!-- WITHOUT SEARCH POPIN -->
                            <ng-container *ngIf="structuresFiltre.length <= LIMIT_STRUCTURES_CHECKBOX">
                                <legend>{{ filtreStructures }}</legend>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input form-check-input" formControlName="selectAllStructuresCheckbox" id="selectAllStructuresCheckbox" />
                                    <label class="custom-control-label select-all" for="selectAllStructuresCheckbox">{{ "filtre.selectAll" | translate }} </label>
                                </div>
                                <div formGroupName="structures">
                                    <dts-select-container class="form-group form-group-custom-control" [selectMode]="false" [selectOnDrag]="true" [dragOverItems]="true" (selectionEnded)="handleDragSelection($event, 'structures')">
                                        <div *ngFor="let item of filtreForm.get('structures').value | keyvalue; let i = index" class="custom-control custom-checkbox" [dtsSelectItem]="item">
                                            <input id="customCheckboxStructure{{ i }}" class="custom-control-input form-check-input" type="checkbox" [formControlName]="item.key" [value]="item.value" />
                                            <label class="custom-control-label" for="customCheckboxStructure{{ i }}">{{ item.key }}</label>
                                        </div>
                                    </dts-select-container>
                                </div>
                            </ng-container>

                            <!-- WITH SEARCH POPIN -->
                            <ng-container *ngIf="structuresFiltre.length > LIMIT_STRUCTURES_CHECKBOX">
                                <legend>{{ filtreStructures }} ({{ selectedStructuresCount }}/{{ totalStructuresCount }})</legend>
                                <a class="btn--icon-before" role="button" (click)="openSelectMoreItemsModal('structures')">Selectionner plus...</a>
                            </ng-container>
                        </fieldset>
                    </div>
                </div>
                <div class="left-box-container" *ngIf="etatsFiltre.length > 0">
                    <div class="form-group form-group-custom-control">
                        <fieldset>
                            <legend>Etat habilitation</legend>
                            <div formGroupName="etats" *ngFor="let item of filtreForm.get('etats').value | keyvalue; let i = index">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input form-check-input" id="customCheckboxEtat{{ i }}" [formControlName]="item.key" [value]="item.value" />
                                    <label class="custom-control-label" for="customCheckboxEtat{{ i }}">{{ item.key | nomenclatures | async }}</label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div class="left-box-container" *ngIf="['CL', 'CL_PM'].includes(typeGestion) && usagesFiltre.length > 0">
                    <div class="form-group form-group-custom-control">
                        <fieldset>
                            <!-- WITHOUT SEARCH POPIN -->
                             <ng-container *ngIf="usagesFiltre.length <= LIMIT_USAGES_CHECKBOX" class="custom-control custom-checkbox">
                                 <legend>Usages</legend>
                                 <div *ngIf="usagesFiltre.length > LIMIT_USAGES_CHECKBOX" class="custom-control custom-checkbox">
                                     <input id="selectAllUsagesCheckbox" type="checkbox" class="custom-control-input form-check-input" formControlName="selectAllUsagesCheckbox" />
                                     <label class="custom-control-label select-all" for="selectAllUsagesCheckbox">{{ "filtre.selectAll" | translate }} </label>
                                 </div>
                                 <dts-select-container class="form-group form-group-custom-control" [selectMode]="false" [selectOnDrag]="true" [dragOverItems]="true" (selectionEnded)="handleDragSelection($event, 'usages')">
                                     <div>
                                         <div *ngFor="let item of filtreForm.get('usages').value | keyvalue; let i = index" formGroupName="usages" [dtsSelectItem]="item">
                                             <div class="custom-control custom-checkbox">
                                                 <input id="customCheckboxUsage{{ i }}" class="custom-control-input form-check-input" type="checkbox" [formControlName]="item.key" [value]="item.value" />
                                                 <label class="custom-control-label" for="customCheckboxUsage{{ i }}">{{ item.key }}</label>
                                             </div>
                                         </div>
                                     </div>
                                 </dts-select-container>
                             </ng-container>

                            <!-- WITH SEARCH POPIN -->
                             <ng-container *ngIf="usagesFiltre.length > LIMIT_USAGES_CHECKBOX" class="custom-control custom-checkbox">
                                 <legend>Usages ({{ selectedUsagesCount }}/{{ totalUsagesCount }})</legend>
                                 <a class="btn--icon-before" role="button" (click)="openSelectMoreItemsModal('usages')">Selectionner plus...</a>
                             </ng-container>
                        </fieldset>
                    </div>
                </div>
                <div class="left-box-container" *ngIf="['CL', 'CL_PM'].includes(typeGestion) && offresFiltre.length > 0">
                    <div class="form-group form-group-custom-control">
                        <fieldset>
                            <legend>Offres</legend>
                            <div formGroupName="offres" *ngFor="let item of filtreForm.get('offres').value | keyvalue; let i = index">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input form-check-input" id="customCheckboxOffre{{ i }}" [formControlName]="item.key" [value]="item.value" />
                                    <label class="custom-control-label" for="customCheckboxOffre{{ i }}">{{ item.key }}</label>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="left-box-bottom">
                <div class="btn-group">
                    <button type="button" class="btn btn--ghost btn--default" (click)="effacerFiltre(); isCollapsed=!isCollapsed;">
                        {{ "filtre.bouton.reinitialiser" | translate }}
                    </button>
                    <button type="submit" class="btn btn--plain btn--primary" (click)="filtrer(); isCollapsed=!isCollapsed;">
                        {{ "filtre.bouton.filtrer" | translate }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
